import { render } from "./QuestionnaireSetPassword.vue?vue&type=template&id=1ffbe6e0&scoped=true&ts=true"
import script from "./QuestionnaireSetPassword.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireSetPassword.vue?vue&type=script&lang=ts"

import "./QuestionnaireSetPassword.vue?vue&type=style&index=0&id=1ffbe6e0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1028913207/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffbe6e0"]])

export default __exports__